"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PaymentManual = require("../../PaymentManual/PaymentManual");
var _payment = require("../../assets/icons/payment");
var _excluded = ["platform", "actionType", "containerId", "callback"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var walletIds = ['EMoney', 'TbcPay', 'Oppa', 'WebMoney'];
var _default = function _default(_ref) {
  var platform = _ref.platform,
    actionType = _ref.actionType,
    containerId = _ref.containerId,
    callback = _ref.callback,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, walletIds.map(function (key) {
    return /*#__PURE__*/_react.default.createElement(_PaymentManual.PaymentManual, {
      key: key,
      platform: platform,
      actionType: actionType,
      type: 'wallet',
      containerId: containerId,
      callback: callback,
      eventKey: key,
      logo: _payment.WalletLogos[key],
      style: {
        margin: '1rem 0'
      }
    });
  }));
};
exports.default = _default;